import { render, staticRenderFns } from "./HouseholdTable.vue?vue&type=template&id=6673b06a&scoped=true&"
import script from "./HouseholdTable.vue?vue&type=script&lang=js&"
export * from "./HouseholdTable.vue?vue&type=script&lang=js&"
import style0 from "./HouseholdTable.vue?vue&type=style&index=0&id=6673b06a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6673b06a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VDataTable,VSpacer,VToolbar,VToolbarTitle})
